import { defineStore } from "pinia";
import axios from "axios";
import i18n from "@/i18n";
import { useAccessDcStore } from "@/stores/AccessDcStore";

export const useUserStore = defineStore("UserStore", {
  state: () => {
    return {
      user: {},
      token: "",
      permissions: [],
      errorMistra: false,
    };
  },
  getters: {},
  actions: {
    getHeader() {
      return {
        Accept: "application/json",
        Authorization: "Bearer " + this.token,
      };
    },
    async setPrefered() {
      // Preferences user
      let url =
        window.VUE_APP_MISTRA_URL + "assenzio/v2/preferences";

      const self = this;

      axios
        .get(url, { headers: this.getHeader() })
        .then((rls) => {
          self.user.preferences = rls.data;
          i18n.global.locale.value = self.user.preferences.language;
          i18n.global.fallbackLocale.value = self.user.preferences.language;
          document
            .querySelector("html")
            .setAttribute("lang", self.user.preferences.language);
          return true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async allAccountsActive() {
      let url =
        window.VUE_APP_MISTRA_URL +
        "base/v2/available-account-list";

      const self = this;

      axios
        .get(url, { headers: this.getHeader() })
        .then((rls) => {
          self.user.accounts = rls.data.length > 0 ? rls.data : [];
          if (!self.user.account && rls.data.length > 0) {
            self.user.account = rls.data[0];
          }
          return true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getAccount() {
      let url =
        window.VUE_APP_MISTRA_URL + "base/v2/active-account";

      const self = this;

      axios
        .get(url, { headers: this.getHeader() })
        .then((rls) => {
          self.user.account = rls.data;
          return true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setUser() {
      // User
      let url = window.VUE_APP_MISTRA_URL + "base/v2/user-info";
      const self = this;
      axios
        .get(url, { headers: this.getHeader() })
        .then((response) => {
          this.user = response.data;
          this.setPermissions();
          this.setIfColocation();
          this.setIfAccess();
          if (
            this.setPrefered() &&
            this.allAccountsActive() &&
            this.getAccount()
          ) {
            this.user.viewLoader = true;
            return true;
          }
        })
        .catch((err) => {
          console.log(err);
          self.user.viewLoader = true;
          self.errorMistra = true;
        });
    },
    async setPermissions() {
      if (!this.user?.role?.pages || this.user.role.pages.length === 0) {
        localStorage.setItem("cdlDisabled", 1);
        return;
      } else {
        localStorage.removeItem("cdlDisabled");
      }
      this.user.role.pages.forEach((elm) => {
        this.permissions.push(elm);
        if (elm.children && elm.children.length > 0) {
          elm.children.forEach((childOne) => {
            this.permissions.push(childOne.name);
            if (childOne.children && childOne.children.length > 0) {
              childOne.children.forEach((childTwo) => {
                this.permissions.push(childTwo.name);
                if (childTwo.children && childTwo.children.length > 0) {
                  childTwo.children.forEach((childThree) => {
                    this.permissions.push(childThree.name);
                  });
                }
              });
            }
          });
        }
      });
    },
    async setIsBiometric() {
      let accessDcStore = useAccessDcStore();
      let url =
        window.VUE_APP_MISTRA_URL + "front/v1/is-biometric";
      axios
        .get(url, { headers: this.getHeader() })
        .then((response) => {
          accessDcStore.isBio = response.data == "true" ? true : false;
          return;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getUsersBiometric() {
      let accessDcStore = useAccessDcStore();
      let url =
        window.VUE_APP_MISTRA_URL +
        "front/v1/users-with-cardholder";
      axios
        .get(url, { headers: this.getHeader() })
        .then((response) => {
          accessDcStore.usersBio = response.data;
          return;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async setIfColocation() {
      this.user.isColocation = false;
      // false finché has-assets/colocation non risponde: HomePage mostra il proprio loader
      this.user.isColocationChecked = false;
      axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "assets/v1/has-assets/colocation",
          { headers: this.getHeader() }
        )
        .then((response) => {
          if (response.data.hasAssets) {
            this.user.isColocation = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.user.isColocation = false;
        })
        .finally(() => {
          this.user.isColocationChecked = true;
        });
    },
    async setIfAccess() {
      this.user.isAccess = false;
      axios
        .get(window.VUE_APP_MISTRA_URL + "assets/v1/lines", {
          headers: this.getHeader(),
        })
        .then((response) => {
          if (response.data.length > 0) {
            this.user.isAccess = true;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
});
